import { useState, useEffect } from 'react'
import { WapprunnerCreate } from 'weblite-web-wapprunner'
import {
  useNavigate,
  getPanelHistory,
  useHistoryCustomBack,
} from 'weblite-router'
import { Meta, WappInput, WappMode } from '@weblite-wapps/protocol'
import { VisibilityHandler } from './components/visibility-handler'
import { CallWappPanel } from '$logic/wapp-panels'
import { hideCall } from '$logic/router'

export interface CallInput {
  token: string
}

export const callAPI = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  refreshCall(_token: string, _input?: WappInput) {},
}

export function Call() {
  const navigate = useNavigate()

  const [wappMeta, setWappMeta] = useState<Meta>()
  const [token, setToken] = useState<string>('')
  const [input, setInput] = useState<WappInput>()

  useEffect(() => {
    callAPI.refreshCall = (innerToken: string, innerInput) => {
      setToken(innerToken)
      setInput(innerInput)

      setWappMeta(CallWappPanel.getWappMeta())
    }
  }, [])

  useHistoryCustomBack(() => {
    const history = getPanelHistory('call')
    const [panelTop] = history.slice(-1)

    if (history.length === 1 || panelTop === 'INIT') hideCall()
    else navigate(-1)
  }, [])

  if (!wappMeta?.wappSessionId || !token) return null
  const { wappSessionId } = wappMeta

  return (
    <VisibilityHandler zIndex={1}>
      <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
        <WapprunnerCreate
          key={token}
          wappSessionId={wappSessionId}
          wappId={wappMeta.wappId}
          mode={WappMode.STATIC}
          input={{ token, ...input } as WappInput}
        />
      </div>
    </VisibilityHandler>
  )
}
